import { QueryClient } from '@tanstack/react-query';
import { ApplicantSummary } from './types';

export const INVITE_TO_INTERVIEW = 'Invite to Interview';

export type ApplicantListCache = {
  applicants?: ApplicantSummary[];
};

export function markApplicantInvited(
  cache: ApplicantListCache | undefined,
  candidateId: string
): ApplicantListCache | undefined {
  if (!cache?.applicants) return cache;
  return {
    ...cache,
    applicants: cache.applicants.map((row) =>
      row.candidate_id === candidateId
        ? { ...row, status: 'invited' as const }
        : row
    ),
  };
}

/** Patch both All / Recommendations lists, then refetch so they cannot drift. */
export function applyInviteToApplicantCaches(
  qc: QueryClient,
  jobId: string,
  candidateId: string
) {
  qc.setQueriesData(
    { queryKey: ['job', jobId, 'applicants'] },
    (old: ApplicantListCache | undefined) =>
      markApplicantInvited(old, candidateId)
  );
  qc.invalidateQueries({
    queryKey: ['applicant', jobId, candidateId],
  });
  qc.invalidateQueries({ queryKey: ['job', jobId, 'applicants'] });
  qc.invalidateQueries({ queryKey: ['jobs'] });
}
